import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateUserEntity } from '../../domain/entities/CreateUpdateUserEntity'

export class CreateUpdateUserModel extends CreateUpdateUserEntity {
    regionIds?: number[]
    phoneNumber = ''
    displayName = ''

  constructor(dataDto: CreateUpdateUserEntity) {
    super()
    mapEntityProperties<CreateUpdateUserModel>(this, dataDto, {
      exclude: ['regions'],
      map: {
        regionIds: dataDto.regions?.map((region) => region.id),
      }
    })
  }
}
